import BaseDatepicker from 'components/atoms/base-datepicker';

import s from './styles.module.scss';

import type { IFormSubItemProps } from './types';
import type { FC } from 'react';

const DateItem: FC<IFormSubItemProps> = ({ formik, option }) => {
  const today = new Date();
  const currentValues = formik.values[option.value as string];

  return (
    <div>
      <label className={s.label}>
        <span>{option.label}</span>
      </label>
      <BaseDatepicker
        onChange={(value) =>
          formik.setFieldValue(option.value as string, value)
        }
        disabled={option?.disabled}
        value={currentValues ? new Date(currentValues) : undefined}
        minDate={option.type === 'min' ? today : undefined}
        maxDate={option.type === 'max' ? today : undefined}
        getPopupContainer={(trigger) => trigger}
      />
    </div>
  );
};

export default DateItem;
